import api from './api'

export default class ApiURpd {

    // Получение кодов направлений подготовки
    static async getSpecialtyCodes(): Promise<any> {
        try {
            return await api.get('/rpd/getSpecialtyCodes')
        } catch (error) {
            return error
        }
    }

    // Получение дисциплин
    static async getDisciplines(specialtyCodeID: string): Promise<any> {
        try {
            return await api.get(`/rpd/getDisciplines?specialtyCodeID=${specialtyCodeID}`)
        } catch (error) {
            return error
        }
    }

    // Получение файлов
    static async getFiles(subjectID: string): Promise<any> {
        try {
            return await api.get(`/rpd/getFiles?subjectID=${subjectID}`)
        } catch (error) {
            return error
        }
    }



    // Создание направления подготовки
    static async createSpecialtyCodes(specialtyCodesName: string, disciplinesList: any): Promise<any> {
        try {
            return await api.post(`/rpd/createSpecialtyCodes?specialtyCodesName=${specialtyCodesName}`, JSON.stringify({disciplines: disciplinesList}), { headers: { "Content-Type": "application/json" } })
        } catch (error) {
            return error
        }
    }

    // Создание дисциплин
    static async createDisciplines(directionTrainingID: string, disciplinesList: any): Promise<any> {
        try {
            return await api.post(`/rpd/createDisciplines?directionTrainingID=${directionTrainingID}`, JSON.stringify({disciplines: disciplinesList}), { headers: { "Content-Type": "application/json" } })
        } catch (error) {
            return error
        }
    }

    // Загрузка файлов
    static async uploadFilesRpd(file: any, disciplineID: string, fileName: string): Promise<any> {
        const formData = new FormData()
        formData.append("rpd", file)

        try {
            return await api.post(`/rpd/uploadFilesRpd?disciplineID=${disciplineID}&fileName=${fileName}`, formData, { headers: { "Content-Type": `multipart/form-data` } })
        } catch (error) {
            return error
        }
    }



    // Редактирование направлений подготовки
    static async editSpecialty(specialtyID: string, specialtyName: string): Promise<any> {
        try {
            return await api.put(`/rpd/editSpecialty?specialtyID=${specialtyID}&specialtyName=${specialtyName}`)
        } catch (error) {
            return error
        }
    }

    // Редактирование дисциплин
    static async editDiscipline(disciplineID: string, disciplineName: string): Promise<any> {
        try {
            return await api.put(`/rpd/editDiscipline?disciplineID=${disciplineID}&disciplineName=${disciplineName}`)
        } catch (error) {
            return error
        }
    }



    // Удаление направлений подготовки
    static async deleteSpecialty(specialtyID: string, specialtyName: string): Promise<any> {
        try {
            return await api.delete(`/rpd/deleteSpecialty?specialtyID=${specialtyID}&specialtyName=${specialtyName}`)
        } catch (error) {
            return error
        }
    }
    
    // Удаление дисциплин
    static async deleteDiscipline(disciplineID: string, disciplineName: string): Promise<any> {
        try {
            return await api.delete(`/rpd/deleteDiscipline?disciplineID=${disciplineID}&disciplineName=${disciplineName}`)
        } catch (error) {
            return error
        }
    }

    // Удаление файлов
    static async deleteFile(fileID: string, fileName: string): Promise<any> {
        try {
            return await api.delete(`/rpd/deleteFile?fileID=${fileID}&fileName=${fileName}`)
        } catch (error) {
            return error
        }
    }

}